import { ReportEstimatesRequest } from '@flexible-reports/store/api/report-cost-estimation/api-types';
import { ReportEstimateDescription } from '@flexible-reports/store/api/report-cost-estimation/types';
import { getFormattedLocale } from '@urc-ui/utils/app-utils';
import { Filter } from '@flexible-reports/store/api/types';

export type QueryFieldsUI = {
  fields: string[];
  filter?: Filter;
};

export type DatePeriodUI = {
  startDate: string;
  endDate: string;
};

export type ReportPeriodUI = {
  datePeriod: DatePeriodUI;
};

export type AccountIdUI = {
  advertiserAccountId?: string;
  managerAccountId?: string;
};

export type ReportEstimateDescriptionUI = {
  query: QueryFieldsUI;
  periods: ReportPeriodUI[];
  format: 'CSV';
  linkedAccounts: AccountIdUI[];
  currencyOfView?: string | null;
};

export type ReportEstimatesRequestUI = {
  accessRequestedAccounts: AccountIdUI[];
  reportEstimateDescriptions: ReportEstimateDescriptionUI[];
};

export const transformToAPIDescription = (desc: ReportEstimateDescriptionUI): ReportEstimateDescription => {
  return {
    query: desc.query,
    locale: getFormattedLocale(),
    periods: desc.periods.map(period => ({
      datePeriod: {
        startDate: period.datePeriod.startDate,
        endDate: period.datePeriod.endDate
      }
    })),
    format: desc.format as any,
    linkedAccounts: desc.linkedAccounts,
    currencyOfView: desc.currencyOfView
  };
};

export const buildReportEstimatesRequest = (request: ReportEstimatesRequestUI): ReportEstimatesRequest => ({
  accessRequestedAccounts: request.accessRequestedAccounts,
  reportEstimateDescriptions: request.reportEstimateDescriptions.map(transformToAPIDescription)
});
